package com.cybersoftsolution.cybersoftsolutionweb.components.items

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyFaIcon
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Composable
fun MenuItem(
    id: String,
    modifier: Modifier = Modifier,
    selected: Boolean = false,
    title: String,
    icon: Resources.FaIconsClassName? = null,
    onClick: () -> Unit,
){

        Row(
            modifier = Modifier
//            modifier = Selected_ItemStyle.toModifier()
                .id(id)
                .padding(leftRight = 20.px)
                .then(modifier)
                .cursor(Cursor.Pointer)
                .onClick { onClick() }
                .transition(
                    Transition.of(
                        property = TransitionProperty.All,
                        duration = 300.ms
                    )
                )
//                .attrsModifier {
//                    attr("href","#${id}content")
//                }

            ,
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ){


                icon?.let {
                    MyFaIcon(
                        modifier = Modifier
                            .fillMaxHeight()
                            .margin(right = 10.px),
//                            .width(20.px),
                        id = "${id}Icon",
                        faIconsClassName = it ,
                    )
                }

                Text(title)
//                SpanText(
//                    text = title,
//                    modifier = Modifier
//                        .thenIf(
//                            condition = icon != null,
//                            other = Modifier.margin(left = 15.px)
//                        )
//                        .id(IdConst.navigationText+selected.toString())
////                .fontSize(16.px)
//                        .fillMaxWidth()
////                .fontFamily("serif")
//                )

        }


}